/** Exact local logo filenames under /public/clients/logos/ (avoids failed .png→.jpg probes). */
export const CLIENT_LOGO_FILES = {
  'abbott-india-ltd': 'abbott-india-ltd.png',
  'acg-pam-pharma': 'acg-pam-pharma.jpg',
  'adm-joinflex-india': 'adm-joinflex-india.jpg',
  'amcor-flexibles-india': 'amcor-flexibles-india.png',
  'amneal-life-sciences': 'amneal-life-sciences.jpg',
  'ashok-leyland-ltd': 'ashok-leyland-ltd.png',
  'asian-paints-ltd': 'asian-paints-ltd.jpg',
  'atlas-copco': 'atlas-copco.jpg',
  'bayer-crop-science': 'bayer-crop-science.png',
  'centaur-pharmaceuticals': 'centaur-pharmaceuticals.jpg',
  'chheda-electricals': 'chheda-electricals.jpg',
  'cilicant-pvt-ltd': 'cilicant-pvt-ltd.jpg',
  'cmm-logistics-pvt-ltd': 'cmm-logistics-pvt-ltd.jpg',
  'coca-cola-india-ltd': 'coca-cola-india-ltd.jpg',
  'craftsman-automation': 'craftsman-automation.jpg',
  'cummins-india-ltd': 'cummins-india-ltd.png',
  'datwyler-pharma-packaging': 'datwyler-pharma-packaging.png',
  'dr-reddys-laboratories': 'dr-reddys-laboratories.png',
  'eka-pak-global-india': 'eka-pak-global-india.jpg',
  'ferrero-india-pvt-ltd': 'ferrero-india-pvt-ltd.jpg',
  'fresenius-kabi-india': 'fresenius-kabi-india.png',
  'highway-industries': 'highway-industries.jpg',
  'ig-international-ltd': 'ig-international-ltd.jpg',
  'indoco-remedies-ltd': 'indoco-remedies-ltd.jpg',
  'indus-biotech-ltd': 'indus-biotech-ltd.png',
  'kalyani-technoforge': 'kalyani-technoforge.jpg',
  'knovea-pharmaceutical-ltd': 'knovea-pharmaceutical-ltd.jpg',
  'lumax-industries-ltd': 'lumax-industries-ltd.jpg',
  'mahindra-cie-automotive': 'mahindra-cie-automotive.jpg',
  'marksans-pharma-ltd': 'marksans-pharma-ltd.jpg',
  'metaforge-engineering': 'metaforge-engineering.jpg',
  'microlabs-ltd': 'microlabs-ltd.jpg',
  'micron-technology-inc': 'micron-technology-inc.png',
  'monsanto-holdings': 'monsanto-holdings.jpg',
  'natco-pharma-ltd': 'natco-pharma-ltd.jpg',
  'nature-delight-dairy': 'nature-delight-dairy.jpg',
  'naval-dockyard-india': 'naval-dockyard-india.jpg',
  'navketan-pharma': 'navketan-pharma.jpg',
  'packtime-innovations': 'packtime-innovations.jpg',
  'parag-dairy': 'parag-dairy.jpg',
  'parle-industries-ltd': 'parle-industries-ltd.png',
  'pepsico-india-ltd': 'pepsico-india-ltd.jpg',
  'puniska-injectables': 'puniska-injectables.png',
  'renata-precision-components': 'renata-precision-components.jpg',
  'saipro-industries': 'saipro-industries.jpg',
  'samvardhana-motherson': 'samvardhana-motherson.png',
  'sanofi-india-ltd': 'sanofi-india-ltd.jpg',
  'sava-healthcare-ltd': 'sava-healthcare-ltd.jpg',
  'schreiber-dynamix-dairies': 'schreiber-dynamix-dairies.jpg',
  'serum-institute-of-india': 'serum-institute-of-india.jpg',
  'shri-bhagwant-rubber': 'shri-bhagwant-rubber.png',
  'siemens-ltd': 'siemens-ltd.jpg',
  'sonai-dairy': 'sonai-dairy.jpg',
  'sophal-pharmaceuticals': 'sophal-pharmaceuticals.jpg',
  'symbiotec-pharmaceuticals': 'symbiotec-pharmaceuticals.jpg',
  'tata-advanced-systems': 'tata-advanced-systems.png',
  'tata-motors-ltd': 'tata-motors-ltd.png',
  'te-connectivity-india': 'te-connectivity-india.png',
  'unichem-laboratories': 'unichem-laboratories.jpg',
  'venkeys-group': 'venkeys-group.jpg',
  'venkys-india-limited': 'venkys-india-limited.jpg',
  'watson-pharma-pvt-ltd': 'watson-pharma-pvt-ltd.jpg',
  'zydus-cadila-healthcare-ltd': 'zydus-cadila-healthcare-ltd.png',
  'zydus-lifescience-ltd': 'zydus-lifescience-ltd.png',
};
